import { PermissionsDTO } from "../../../models/api-user/permissions/permissions.response.model";


export class RolesRequest{
    name: string;
    permission: PermissionsDTO[];  
    
}

export class RolesRequestList{
    id?:number;
    name: string;
    pageNumber: number;
    pageSize: number;
    sortBy: string;
    
}

export class RoleRequestAddPermission{
    listaPermissions: number[];
}

export class RoleRequestRemovePermission{
    listaPermissions: number[];
}